import helpers from '../helpers';
import moment from 'moment';

export default {

    data() {
        return {
            reasons: this.$store.state.config.reasons,
        }
    },
    
    props: [
        'marktime'
    ],

    computed: {
        workingDays() {            
            let days = 0;
            var workingHours = (this.currentUser.isPartTime) ? this.currentUser.partTime : 8
            var totalTimeOff = 0;

            this.marktime.marktime.forEach(day => {
                if (day.type === 'D' && day.halfday) days += 0.5
                if (day.type === 'NV') {
                    days += 1
                    if (day.timeOff) totalTimeOff += day.timeOff;
                }
                if (day.type === '0' && day.timeFrom && !day.specialHours) days += 1
            })

            days -= Math.floor(totalTimeOff / workingHours);

            return days
        },

        workingHours() {

            var totalHours = 0;
            var workingHours = (this.currentUser.isPartTime) ? this.currentUser.partTime : 8;

            this.marktime.marktime.forEach(day => {
                if ((day.type === '0' || day.type === 'D') && day.timeFrom) {
                    var duration = helpers.getDuration(day)
                    totalHours += duration

                    if (day.overtime) {
                        totalHours -= parseFloat(day.overtime)
                    }
                }
                if (day.type === 'NV') {
                    if (day.timeFrom) totalHours += helpers.getDuration(day);
                }
            })

            return totalHours
        },

        overtimeHours() {
            var overtime = 0;
            this.marktime.marktime.forEach((day) => {
                if (day.overtime) overtime += parseFloat(day.overtime)
            })
            return overtime
        },

        totalDays() {
            var total = 0;
            total += this.workingDays
            this.reasons.forEach((reason) => {
                total += this.getReasonDays(reason.id)
            })
            return total
        },

        totalHours() {
            var total = 0;

            total += this.workingHours
            this.reasons.forEach(reason => {
                total += this.getReasonHours(reason.id)
            })
            total += this.overtimeHours

            return total
        },

        vouchers() {
            return Math.ceil(this.workingDays)
        }
    },

    methods: {

        isSunday(day) {
            var date = moment({
                year: this.marktime.year,
                month: this.marktime.month,
                day: day + 1
            })
            return date.day() == 0;
        },

        isSaturday(day) {
            var date = moment({
                year: this.marktime.year,
                month: this.marktime.month,
                day: day + 1
            })
            return date.day() == 6;
        },

        getReasonDays(reason) {
            
            var days = 0;
            var workingHours = (this.currentUser.isPartTime) ? this.currentUser.partTime : 8;
            
            this.marktime.marktime.forEach((day, index) => {
                if (day.type === reason) {
                    if (reason === 'D' && day.halfday) days += 0.5
                    else if (reason === 'NV') days += 0
                    else if (reason === 'SLC' && (this.isSaturday(index) || this.isSunday(index))) days += 0
                    else days += 1
                }
            })

            if (reason === 'NV') {
                var totalTimeOff = 0;
                this.marktime.marktime.forEach(day => {
                    if (day.type === reason) {
                        if (reason === 'NV') {                    
                            if (day.timeOff) totalTimeOff += day.timeOff;
                        }
                    }
                })
                days = Math.floor(totalTimeOff / workingHours);
            }

            return days
        },

        getReasonHours(reason) {

            var hours = 0;
            var workingHours = (this.currentUser.isPartTime) ? this.currentUser.partTime : 8

            this.marktime.marktime.forEach((day, index) => {
                if (day.type === reason) {
                    
                    if (reason === 'D') {
                        hours += (day.halfday) ? workingHours / 2 : workingHours;
                    } else if (reason === 'NV') {                    
                        if (day.timeOff) hours += day.timeOff;
                    }
                    else if (reason === 'SLC' && (this.isSaturday(index) || this.isSunday(index))) hours += 0
                    else {
                        hours += (this.currentUser.isPartTime) ? this.currentUser.partTime : 8
                    }
                }
            })

            return hours;

        }

    }
}